// eslint-disable-next-line import/no-anonymous-default-export
export default {
  commonTxt: {
    nodata: "데이터가 없습니다.",
    loading: "로딩중",
    more: "더보기"
  },
  main: {
    logo: "임상시험 자원자 모집 사이트",
    slide: {
      title: "조회수 많은 연구",
      detail: "상세보기"
    },
    closing: {
      title: "모집 마감 임박 공고",
      txt: "일 후 마감"
    },
    research: {
      tabTitle1: "건강한 자원자 참여 연구",
      tabTitle2: "질환 자원자 참여 연구"
    },
    counter: {
      count1: "금년 지원한 자원자 수",
      count2: "금년 전체 진행 연구 수",
      count3: "현재 진행중인 연구 수",
      persons: "명",
      case: "건"
    },
    banner: {
      txt1:
        "카카오톡 플러스친구 추가 하시면\n1:1로 쉽고 빠르게 상담 받으실 수 있습니다.",
      txt2: "플러스친구 서울대학교 임상시험센터",
      txt3: "+ 추가 방법 확인"
    }
  },
  login: {
    placeholderId: "이메일(ID) 입력",
    placeholderPw: "비밀번호 입력",
    buttonTxt: "로그인",
    user: "님",
    logout: "로그아웃",
    mypage: "마이페이지",
    saveId: "아이디 저장",
    signIn: "회원가입",
    findId: "아이디 찾기",
    findPw: "비밀번호 찾기"
  },
  join: {
    title: "회원가입",
    titleStep1: "회원정보 작성",
    titleStep2: "임상시험 자원서 작성",
    password: "비밀번호",
    confirmPw: "비밀번호 확인",
    duplicate: "※ 이미 등록된 이메일(ID)입니다.",
    always: "상시 지원 신청",
    alwaysTxt:
      "* 상시 지원을 신청할 경우 각 임상시험 모집의 담당자가 참여 가능 여부를 확인하기 위해 연락을 취할 수 있음을 알려 드립니다.",
    btnJoin: "가입하기",
    btnCancel: "취소하기",
    alertCancel: "회원가입을 취소하시겠습니까?",
    failJoin: "회원가입에 실패하였습니다.",
    completeTit: "회원가입이 완료되었습니다!",
    completeTxt1: "회원님의 이메일(ID)는",
    completeTxt2: "입니다.",
    completeTxt3: "회원님의 자원서와 적합한 모집을 확인하고 지원해 보세요.",
    completeBtn: "시작하기"
  },
  findAccount: {
    titleId: "아이디 찾기",
    titlePw: "비밀번호 찾기",
    titleChangePw: "비밀번호 변경",
    mail: "이메일",
    placeholderMail: "이메일(ID)을 입력해주세요",
    name: "이름",
    placeholderName: "이름을 입력해 주세요",
    gender: "성별",
    rdoMale: "남",
    rdoFemale: "여",
    birth: "생년월일",
    phone: "휴대 전화번호",
    placeholderPh: "휴대 전화번호를 입력해 주세요.",
    newPw: "새 비밀번호",
    confirmPw: "비밀번호 확인",
    btnTxtId: "아이디 찾기",
    btnTxtPw: "비밀번호 찾기",
    btnTxtLogin: "로그인 하기",
    btnTxtHome: "홈으로",
    btnTxtChange: "비밀번호 변경",
    btnTxtCancel: "취소하기",
    idResultTitle: "조회결과",
    idResult:
      "해당 정보로 조회된 아이디이며, 개인정보 보호를 위해 일부는 *로 표기됩니다.",
    errorId: "조회된 아이디가 없습니다.",
    errorMail: "※ 이메일(ID) 또는 비밀번호가 일치하지 않습니다.",
    withdrawMail: "탈퇴한 이메일(ID)입니다.",
    alertPw: "비밀번호 변경이 완료되었습니다.",
    errorPw: "비밀번호 변경이 실패하였습니다.",
    errPwConfirm: "※ 영문 대/소문자+숫자+특수문자 조합 9자리 이상으로 설정해 주세요.",
    wrongCnt: "허용 가능한 로그인 시도 횟수를 초과하여 로그인이 차단되었습니다. 카카오톡 플러스친구 서울대병원 임상시험센터 혹은 02-741-4221로 문의해주시길 바랍니다."
  },
  footer: {
    addr:
      "우)03080 서울대학교병원 임상시험센터 서울특별시 종로구 대학로 101(연건동 28-21)",
    privarcyHref: "/kr/PrivacyPage",
    privarcyTxt: "개인정보 처리방침",    
    familySite: "패밀리사이트",
    family: [
      { id: 0, href: "https://www.snu.ac.kr/", txt: "서울대학교" },
      { id: 1, href: "http://medicine.snu.ac.kr/", txt: "서울대학교 의과대학" },
      // { id: 2, href: "http://clinpharm.snu.ac.kr/", txt: "서울대학교" },
      // {
      //   id: 3,
      //   href: "http://www.snu.ac.kr/index.html",
      //   txt: "서울대학교 대학원 협동과정·임상약리학 전공 페이지"
      // },
      { id: 2, href: "http://www.snuh.org/intro.do", txt: "서울대학교병원" },
      {
        id: 3,
        href: "http://ctc.snuh.org/",
        txt: "서울대학교병원 의생명연구원"
      },
      {
        id: 4,
        href: "https://hrpp.snuh.org/pub/_/singlecont/view.do",
        txt: "서울대학교병원 임상연구윤리센터(HRPP)"
      }
    ]
  },
  navigation: [
    {
      name: "임상시험센터",
      children: [
        "센터소개",
        "임상시험 참여의 의의",
        "절차 안내",
        "스크리닝 검사 및 입원 안내",
        "서울대학교병원 앱 이용 안내"
      ]
    },
    {
      name: "연구정보",
      children: ["임상시험 모집정보"]
    },
    {
      name: "Contact Us",
      children: ["FAQ", "오시는길"]
    },
    {
      name: "나의 참여정보",
      children: ["회원정보", "임상시험 자원서", "자원 내역", "내 문의 현황"]
    }
  ],
  infomation: {
    txt: "임상시험센터 자원자 모집 담당자 : ",
    contact: "02-741-4221",
    time: " 평일 오전 9시~오후 6시"
  },
  about: {
    indroduce: {
      title: "서울대학교병원 임상시험센터 소개",
      Paragraph1:
        "서울대학교병원 임상시험센터는 [임상시험관리기준(KGCP)]과 ICH 및 FDA 가이드라인과 같은 국제적인 기준에 따라 과학적이고 윤리적인 임상 시험이 이뤄질 수 있도록 최적의 연구환경을 제공함으로써 임상시험 수행 전반의 선진화를 도모하고자 1995년에 설립되었습니다. 이후 2004년에는 국내 최초로 보건복지부 지정 지역임상시험센터로, 지난 2012년도에는 역시 국내 최초로 보건복지부로부터 임상시험글로벌선도센터(GREATS)로 지정받아 임상시험의 세계적 경쟁력을 확보해나가고 있습니다.",
      Paragraph2:
        "서울대학교병원 임상시험센터는 성인, 종양, 소아, 의료기기 분야 별로 각각의 공간과 시설을 갖추어 분야별 특성에 맞게 전문적으로 운영하고 있으며, 신약을 포함한 각종 의약품과 의료기기의 효능 및 안전성 평가, 생물학적동등성시험 등을 수행하기 위한 기본적인 연구인력, 연구시설 및 행정지원을 제공합니다. 서울대학교병원의 연구자는 물론 산학연 협동 연구를 위해 적절한 자격과 조건을 갖춘 연구자는 누구라도 서울대학교병원 임상시험센터를 이용할 수 있습니다.",
      Paragraph3:
        "서울대학교병원 임상시험센터는 AAHRPP, WHO FERCAP 인증 등을 통해 임상연구에 참여하는 연구대상자의 권리 보호와 안전 제고에 만전을 기하고 있습니다. 서울대학교병원 임상시험센터에서 수행되는 윤리적이고 과학적인 임상시험에 여러 자원자분들의 적극적인 참여를 바랍니다.",
      Paragraph4:
        "자세한 내용은 서울대학교병원 임상시험센터 홈페이지를 방문하세요.",
      link: "http://ctc.snuh.org/"
    },
    meaning: {
      title: "임상시험 참여의 의의",
      Paragraph1:
        "당뇨병이나 알츠하이머, 아토피와 같은 질병을 가진 사람들을 치료하기 위해 조금 더 효과 있는 의약품을 개발하는데 도움을 줄 수 있다면 어떨지 상상해 보셨나요? 서울대학교병원 임상시험센터는 다양한 질병을 치료하기 위해 임상시험용 의약품, 제약 및 생명 공학 분야에서 활발한 연구를 하고 있는 기업과 파트너가 되어 임상시험을 수행하고 있습니다. 서울대학교병원 임상시험센터의 참여자가 되는 것은 다음과 같은 의미가 있습니다.",
      Paragraph2: "온라인으로 신청하거나 전화 문의 주세요.",
      list: [
        {
          id: 1,
          txt:
            "만성적인 혹은 중증의 질병으로 고통 받는 환자들의 치료를 도울 수 있다는 보람을 느낄 수 있습니다."
        },
        {
          id: 2,
          txt:
            "임상시험에 대한 사회의 부정적인 인식 개선에 이바지 할 수 있습니다."
        },
        {
          id: 3,
          txt:
            "시험의 종류에 따라서는 총체적인 건강검진 서비스를 받을 수 있습니다."
        },
        {
          id: 4,
          txt: "임상시험에 성실히 참여해 주신 보답으로 사례비를 받습니다."
        },
        {
          id: 5,
          txt: "새로운 친구를 사귈 수 있는 기회가 제공됩니다."
        },
        {
          id: 6,
          txt: "일상 생활에서 벗어나 휴식을 취할 수 있습니다."
        },
        {
          id: 7,
          txt:
            "하루 방문하여 채혈하는 연구에서부터 한 달 입원하여 진행하는 연구까지 다양한 연구가 있기 때문에 본인에게 맞는 일정으로 참여하실 수 있습니다."
        }
      ]
    },
    process: {
      title: "절차안내",
      processData: [
        {
          id: 1,
          title: "전화스크리닝",
          imgName: "process_phone",
          cont: `홈페이지 또는 전화를 통해 임상시험에 지원하게 되면 자원자 콜센터와 통화를 하게 됩니다.\n자원자 콜센터는 월요일~금요일 오전 9시에서 오후 6시까지입니다.\n전화스크리닝 담당자는 여러분이 연구에 기본적인 자격이 되는지 말해줄 것이며, 약 복용 관련을 포함한 병력에 대해서 질문을 드릴 것입니다. 정직하게 대답해주시길 부탁드리며, 이는 여러분이 안전하게 임상시험을 하는데 필수적인 요건입니다.`
        },
        {
          id: 2,
          title: "스크리닝 약속",
          imgName: "process_appointment",
          cont:
            "전화스크리닝을 통과하면 스크리닝 약속을 잡게 될 것입니다. 스크리닝 이전에는 보통 10시간 이상 금식하셔야 하며, 신분증을 가지고 제 시간에 방문하셔야 합니다. 약속된 시간에 방문하지 않으시면, 추후 연구에 참여할 기회를 갖는데 불이익이 있을 수 있으므로, 최소 하루 전에는 취소 연락을 주시기 바랍니다.\n\n스크리닝 이전에 숙지하셔야 하는 내용들은 일반적으로 다음과 같습니다.\n\n- 충분한 휴식과 수면 스크리닝 전날 충분한 수면을 취하지 않으시면 스크리닝 탈락 가능성이 높아, 재검을 위해 다시 방문하게 되실 수 있으므로 제한합니다"
        },
        {
          id: 3,
          title: "동의서 작성",
          imgName: "process_agree",
          cont:
            "사전 검사가 이루어지기 전에 동의서를 읽을 수 있도록 해드릴 것입니다. 동의서에는 전체 연구에 대한 매우 상세한 정보가 포함되어 있습니다. 이 문서에는 연구 목적, 투여하는 약의 용량, 채혈 횟수와 양, 이 약과 관련하여 보고된 부작용을 포함한 연구에서 행해질 모든 절차가 들어 있습니다. 여러분이 연구에서 하게 될 역할과 잠재적인 위험에 대해 이해할 수 있도록 동의서 전체를 읽는 것은 매우 중요합니다. 스태프가 연구에 대해 설명할 것이며, 여러분이 가지고 있는 궁금증에 대한 답변을 해드릴 것입니다. 우리는 여러분이 동의서를 읽고 이해하였다는 것을 알 수 있도록 서명을 요청드릴 것입니다."
        },
        {
          id: 4,
          title: "스크리닝 과정",
          imgName: "process_screening",
          cont:
            "연구 참여 동의서를 작성한 후에는 연구마다 조금씩 차이가 있겠지만, 일반적으로 먼저 스크리닝실에서 키와 몸무게, 활력징후(체온, 혈압, 맥박)를 측정하고, 외래에서 채혈 및 심전도검사, 그리고 소변검사를 합니다. 검사가 종료되면 다시 스크리닝실로 돌아와 신체검진을 한 뒤 입원 혹은 외래 방문과 관련하여 사전에 숙지해야 할 내용들을 전달 받은 뒤에 귀가 하실 수 있습니다. 스크리닝 과정에서 소요되는 시간은 연구마다 조금씩 차이가 있겠습니다만, 연구관련 설명 및 동의서 작성을 포함하여 약 2-3시간 정도 소요됩니다."
        },
        {
          id: 5,
          title: "자원자로 선정",
          imgName: "process_vounteer",
          cont:
            "스크리닝이 끝난 뒤에는 연구자가 스크리닝시 실시한 각종 검사 결과를 검토한 후, 특별한 사정이 없는 한 1-2일 후 연구 참여 가능 여부에 대해 유선으로 알려드립니다."
        },
        {
          id: 6,
          title: "입원",
          imgName: "process_hospital",
          cont:
            "연구에 따라서 조건이 달라지긴 하지만, 보통 투약 전날 오후 4시까지 의생명연구원 3층 연구병동으로 입원을 합니다. 입원 병실은 보통 4-6인실로, 같은 성별로 구성된 병실을 사용하게 됩니다. 병동 도착 후 입원 생활에 대해 전반적인 안내를 받고, 소지품검사를 받게 되며, 지정된 병실 및 침상으로 가셔서 환의로 갈아 입습니다. 연구병동 내 욕실에는 샴푸, 비누, 치약, 샤워젤, 바디로션 등이 비치되어 있으며, 세탁실에 공용 세탁기를 두어 비치된 세제로 세탁을 할 수 있습니다. 입원 중 개인 소지품은 병동에서 제공하는 열쇠가 있는 사물함에 보관하시면 되며, 입원 기간 동안에는 외출, 외박, 면회 간식섭취가 금지됩니다."
        },
        {
          id: 7,
          title: "첫째날",
          imgName: "process_day1",
          cont:
            "첫째날은 연구마다 차이가 있겠지만 연구 진행 기간 중 가장 많은 절차들이 수행되는 날입니다. 모든 연구 절차들이 정해진 시간에 이루어지기 때문에 시간을 지키면서 동시에 정확한 데이터를 확보하기 위해 가장 많은 인원의 연구자들이 참여합니다. 첫째날의 대략적인 일정은 아침 7시 50분 쯤 기상하여, 소변검사를 한 뒤, 8시부터 점심 식사 전까지 채혈, 활력징후, 신체검진, 심전도 등의 검사가 정해진 시간에 수행됩니다. 투약은 보통 8시-9시 경에 시행되며, 첫째날 아침엔 보통 금식이므로, 식사는 투약 후 4시간 뒤부터 가능하며, 식수섭취와 화장실 출입의 경우에도 투약 2시간 후부터 가능하다는 제약이 있을 수 있습니다."
        },
        {
          id: 8,
          title: "투약",
          imgName: "process_medication",
          cont:
            "앞서 언급한 바와 같이 첫째날에 보통 투약이 있습니다. 그 어떤 것보다 여러분의 안전이 가장 중요하기 때문에 투약이 이루어지는 날에는 연구자가 병동에 상주하여 계속 모니터링을 합니다. 투약 전과 비교하여 작은 불편함이라도 생겼을 경우 연구진으로부터 신속하게 도움을 받으실 수 있습니다."
        },
        {
          id: 9,
          title: "식사",
          imgName: "process_meal",
          cont:
            "금식이 필요한 경우를 제외하고 입원 전 기간 동안 식사가 제공됩니다. 연구에 따라 식사유형이 정해져 있거나 혹은 식사량이 정해져 있을 수 있어 여러분이 식사를 원하는 대로 조절하지 못할 수 있습니다. 또한 식사시간에 있어서도 연구에 따라 정해진 시간에만 식사가 가능할 수도 있습니다."
        },
        {
          id: 10,
          title: "활동",
          imgName: "process_acivity",
          cont:
            "서울대학교병원 임상시험센터 연구병동은 여러분들의 편의를 위해 여러 가지 노력을 하고 있습니다. 휴게실을 마련하여 비디오게임 및 보드 게임을 즐길 수 있으며, TV 시청이 가능합니다. 또한, 만화책을 비롯한 다양한 서적들을 비치하여 쾌적한 독서 환경을 조성하였습니다. 별도의 컴퓨터는 없으므로, 개인 노트북을 가져오셔서 사용하시면 됩니다."
        },
        {
          id: 11,
          title: "퇴원",
          imgName: "process_discharged",
          cont:
            "입원기간 정해진 모든 연구 절차가 종료되면, 퇴원을 하실 수 있습니다. 퇴원 시간 조절은 어려우며, 연구에 따라 다르지만, 아침식사 후 보통 10시에 퇴원하는 것이 일반적입니다."
        },
        {
          id: 12,
          title: "추가 방문 또는 전화",
          imgName: "process_phone",
          cont:
            "재검사 등으로 인해 추가 방문이 필요한 경우가 있습니다. 이러한 경우에는 여러분께 직접 전화 연락을 드려 방문을 요청 드릴 수도 있습니다."
        },
        {
          id: 13,
          title: "보상",
          imgName: "process_reward",
          cont:
            "우리는 가능한 한 여러분의 시간과 노력을 보상해드릴 것입니다. 통장 사본을 제출하여 주시면 일반적인 경우 연구 종료 후 21일 내에 입금될 것입니다."
        }
      ]
    },
    subjectguide: {
      title: "스크리닝 검사 및 입원 안내",
      section1: {
        title: "임상시험 설명회 및 스크리닝 검사 방문 안내",
        subTitle: "임상시험 설명회 및 스크리닝 검사 방문 안내",
        list: [
          "임상시험의 의의",
          "방문 전 확인사항",
          "방문 전 주의사항",
          "임상시험 설명회 및 스크리닝 검사 참여 절차",
          "동의서 및 스크리닝시트 작성시 주의사항",
          "임상시험 참여시 제한사항",
          "검사 후 진행과정"
        ]
      },
      section2: {
        title: "입원 생활 안내",
        subTitle: "연구병동 입원생활 안내",
        list: ["입원생활 관련", "연구에 따른 대상자 수칙"]
      }
    },
    appguide: {
      title: "서울대학교병원 앱 이용 안내",
      title2: "서울대학교병원 모바일 애플리케이션 앱 이용안내",
      cont:
        "서울대학교병원은 스마트폰 상에서 홈페이지를 이용하시는 분들을 위한 서울대학교병원 모바일 애플리케이션을 제작하였습니다.\n 병원 내에서 편리하게 진료를 받는 것은 물론, 병원 밖에서도 쉽게 건강 관리를 할 수 있도록 다양한 기능을 제공합니다.\n 앱에도 진료예약, 예약일정확인, 의료진소개, 병원소식 등을 제공하고 있으며, 구글 플레이 스토어, 애플 앱스토어에서 ‘서울대학교병원’을 검색하여 설치할 수 있습니다.",
      appTxt: "아이폰 앱",
      androidTxt: "안드로이드 앱",
      downTxt: "[다운로드]"
    }
  },
  faq: {
    title: "자주하는 질문",
    list: [
      {
        id: 0,
        tabName: "자주하는 질문",
        cont: [
          {
            id: 0,
            tabName: "자원하기",
            que: "내가 참여할 수 있나요?",
            ans:
              "임상시험마다 참여 요구 사항이 다르므로, 전화 상담->의료진 상담->동의서 작성->신체 검사 과정을 통해 참여할 수 있습니다."
          },
          {
            id: 1,
            tabName: "임상시험",
            que: "진행중인 임상시험에 대해 볼 수 있나요?",
            ans:
              "'진행중인 연구' 로 들어가거나 자원자 모집 센터로 전화주시면 자세한 정보를 얻을 수 있습니다."
          },
          {
            id: 2,
            tabName: "입원",
            que: "가족과 친구들이 방문 할 수 있나요?",
            ans:
              "우리는 연구의 정확한 결과와 연구 참여자의 기밀을 보장하기 위해 방문자를 허용하지 않습니다. 병동 안에서 새로운 친구를 만들어 보는 것을 권합니다."
          },
          {
            id: 3,
            tabName: "자원하기",
            que: "임상시험 참여의 위험과 혜택은 무엇인가요?",
            ans:
              "잠재적인 위험과 혜택은 연구마다 다르며, 임상시험 참여에 동의하기 전에 위험과 혜택에 대한 설명을 들을 수 있습니다. 또한, 설명되지 않은 부분에 대한 궁금증이 있다면 의료진에게 질문할 수 있습니다."
          },
          {
            id: 4,
            tabName: "자원하기",
            que: "누가 연구에 참여할 수 있나요?",
            ans:
              "센터에서 수행되는 임상시험은 일반적으로 만 19세 이상이셔야 참여가 가능하지만, 의학적인 자격 요건은 연구 마다 다양합니다.\n1상 임상시험은 연구 계획서에 의해 결정된 엄격한 건강한 자원자 자격 기준을 갖춘 사람만이 참여가 가능합니다. 자격 기준은 흡연, 의약품, 약물 사용, 알코올 등을 포함할 수 있습니다.\n2상이나 3상 임상시험은 특정한 의학적인 조건을 가지고 있으면서, 1상과 비슷한 자격 기준을 갖추신 분들이 참여 가능합니다."
          },
          {
            id: 5,
            tabName: "임상시험",
            que: "임상시험이란 무엇인가요?",
            ans:
              "'임상시험'이란 임상시험용의약품의 안전성과 유효성을 증명할 목적으로, 해당 약물의 약동(藥動)-약력(藥力)-약리(藥理)-임상(臨床) 효과를 확인하고 이상반응을 조사하기 위하여 사람을 대상으로 실시하는 시험 또는 연구를 말합니다.\n임상시험은 아직 확인되지 않은 사항을 알아보기 위한 학술적인 활동이므로, 질병의 예방-진단-치료를 위한 일반적인 방법과는 다른 측면이 있습니다.\n임상시험을 통해 새로운 의약품, 의료기기, 의료기술이 개발되고 나면, 이는 질병의 예방-진단-치료를 위해 사용할 수 있는 표준적인 방법이 될 수 있습니다."
          },
          {
            id: 6,
            tabName: "자원하기",
            que: "지원 후 취소가 가능한가요?",
            ans:
              "네, 가능합니다.\n임상시험은 자발적으로 참여하는 것이므로 건강 검진 도중 혹은 임상시험에 참여하고 있는 도중이라도 자유롭게 동의 철회가 가능하며, 어떠한 불이익도 발생하지 않습니다.\n다만, 임상 시험 도중 철회했다면 검진을 위해 의사가 재방문을 요청드릴 수도 있습니다."
          },
          {
            id: 7,
            tabName: "임상시험",
            que: "개인 정보는 비밀로 유지되나요?",
            ans:
              "여러분의 개인 정보는 서울대학교병원 직원에 의해서 보호될 것이며, 법에 의해 요구되지 않는 한 여러분의 정보는 제공되지 않을 것입니다.\n그러나, 임상 시험 의뢰 기관 및 식약청 등 관련 규제 기관이 의료 기록과 신분 확인을 위해 이름, 주소 등의 개인 정보를 점검할 수도 있으며, 필요하다면 검사 기간 동안 복사할 수도 있습니다. 이와 같이 정보 사용이 불가피한 경우가 있으므로, 개인 정보가 절대적으로 보호되는 것은 아닙니다."
          }
        ]
      },
      {
        id: 1,
        tabName: "임상시험",
        cont: [
          {
            id: 0,
            que: "진행중인 임상시험에 대해 볼 수 있나요?",
            ans:
              "'진행중인 연구' 로 들어가거나 자원자 모집 센터로 전화주시면 자세한 정보를 얻을 수 있습니다."
          },
          {
            id: 1,
            que: "임상시험이란 무엇인가요?",
            ans:
              "'임상시험'이란 임상시험용의약품의 안전성과 유효성을 증명할 목적으로, 해당 약물의 약동(藥動)-약력(藥力)-약리(藥理)-임상(臨床) 효과를 확인하고 이상반응을 조사하기 위하여 사람을 대상으로 실시하는 시험 또는 연구를 말합니다.\n임상시험은 아직 확인되지 않은 사항을 알아보기 위한 학술적인 활동이므로, 질병의 예방-진단-치료를 위한 일반적인 방법과는 다른 측면이 있습니다.\n임상시험을 통해 새로운 의약품, 의료기기, 의료기술이 개발되고 나면, 이는 질병의 예방-진단-치료를 위해 사용할 수 있는 표준적인 방법이 될 수 있습니다."
          },
          {
            id: 2,
            que: "임상시험에 참여하는 것은 위험한가요?",
            ans:
              "임상시험의 위험성은 임상시험마다 다르며, 의학연구윤리심의위원회(IRB)가 임상시험의 위험 수준과 위험에 대비하기 위해 마련된 방법이 적절한지를 확인한 후 임상시험의 수행을 승인합니다.\n따라서, 임상시험의 위험은 임상시험 계획 단계에서 최소화될 수 있습니다. 물론 연구자 또한 임상시험 수행 중 발생할 수 있는 위험을 지속적으로 관리할 것입니다."
          },
          {
            id: 3,
            que: "임상시험에 참여하면 개발중인 약을 먹게 되나요?",
            ans:
              "이미 개발된 약이나 위약(가짜약)을 먹는 대조군으로 배정되는 경우, 개발중인 약을 먹지 않을 수도 있습니다."
          },
          {
            id: 4,
            que: "새로운 약물은 어떻게 승인되나요?",
            ans:
              "광범위한 테스트 및 승인 과정을 거쳐야 합니다. 먼저 임상시험용 의약품은 엄격한 비임상 시험 과정을 거칩니다.\n규제 기관에 의해 다음 단계가 허용되면 임상 시험을 통해 사람의 안전성을 확보하기 위한 시험이 실시됩니다.\n그 후 규제기관이 승인을 하게 되면 임상시험용 약물은 장애를 가진 환자를 대상으로 안전성과 유효성을 시험합니다.\n그 후 스폰서는 약물에 대한 승인/거절 혹은 추가 시험을 필요로 한다는 보고서를 규제 기관에 제출합니다."
          },
          {
            id: 5,
            que: "지원 후 취소가 가능한가요?",
            ans:
              "네, 가능합니다.\n임상시험은 자발적으로 참여하는 것이므로 건강 검진 도중 혹은 임상시험에 참여하고 있는 도중이라도 자유롭게 동의 철회가 가능하며, 어떠한 불이익도 발생하지 않습니다.\n다만, 임상 시험 도중 철회했다면 검진을 위해 의사가 재방문을 요청드릴 수도 있습니다."
          },
          {
            id: 6,
            que: "임상시험 참여자의 권리와 복지는 어떻게 보호되나요?",
            ans:
              "임상시험은 자격을 갖춘 의료진에 의해, 임상시험 참여자를 보호하는 규정과 임상시험 수행 방법에 대한 기준에 따라 수행됩니다.\n예를 들면 의학연구윤리심의위원회 (IRB, Institutional Review Board)는 연구 계획서와 관련 자료들을 검토하여, 연구가 과학적이고 윤리적으로 이루어질 수 있도록 해주며, 임상시험 참여자들에게 연구가 수행되는 이유와 수행 과정, 관련된 위험과 이전 연구의 결과를 포함한 정보를 주는 과정을 감독하고 있습니다."
          },
          {
            id: 7,
            que: "개인 정보는 비밀로 유지되나요?",
            ans:
              "여러분의 개인 정보는 서울대학교병원 직원에 의해서 보호될 것이며, 법에 의해 요구되지 않는 한 여러분의 정보는 제공되지 않을 것입니다.\n그러나, 임상 시험 의뢰 기관 및 식약청 등 관련 규제 기관이 의료 기록과 신분 확인을 위해 이름, 주소 등의 개인 정보를 점검할 수도 있으며, 필요하다면 검사 기간 동안 복사할 수도 있습니다. 이와 같이 정보 사용이 불가피한 경우가 있으므로, 개인 정보가 절대적으로 보호되는 것은 아닙니다."
          }
        ]
      },
      {
        id: 2,
        tabName: "보상비",
        cont: [
          {
            id: 0,
            que: "보상비가 있나요?",
            ans:
              "네. 연구 참여에 대한 보상을 받으실 수 있습니다.\n보상비는 연구 기간과 종류에 따라 다르며, 구체적인 보상비는 '진행중인 연구'에서 확인하실 수 있습니다."
          },
          {
            id: 1,
            que: "보상비를 어떻게 받을 수 있나요?",
            ans: "일반적인 경우 연구 종료 후 3-4주 이내에 입금될 것입니다."
          }
        ]
      },
      {
        id: 3,
        tabName: "자원하기",
        cont: [
          {
            id: 0,
            que: "내가 참여할 수 있나요?",
            ans:
              "임상시험마다 참여 요구 사항이 다르므로, 전화 상담->의료진 상담->동의서 작성->신체 검사 과정을 통해 참여할 수 있습니다."
          },
          {
            id: 1,
            que: "임상시험 참여의 위험과 혜택은 무엇인가요?",
            ans:
              "잠재적인 위험과 혜택은 연구마다 다르며, 임상시험 참여에 동의하기 전에 위험과 혜택에 대한 설명을 들을 수 있습니다. 또한, 설명되지 않은 부분에 대한 궁금증이 있다면 의료진에게 질문할 수 있습니다."
          },
          {
            id: 2,
            que: "여자도 참여 가능할까요?",
            ans:
              "네. 모든 연령대의 남녀는 자원자가 될 수 있습니다.\n폐경기 여성을 포함한 여성 자원자를 필요로 하고 있으며, 항상 여성 자원자 연구가 있는 것은 아니지만 연구가 있을 경우 먼저 자원하신 분들께 연락을 드리고 있으므로, 상시 지원 부탁 드립니다."
          },
          {
            id: 3,
            que: "지원 후 취소가 가능한가요?",
            ans:
              "네, 가능합니다.\n임상시험은 자발적으로 참여하는 것이므로 건강 검진 도중 혹은 임상시험에 참여하고 있는 도중이라도 자유롭게 동의 철회가 가능하며, 어떠한 불이익도 발생하지 않습니다.\n다만, 임상시험 도중 철회했다면 검진을 위해 의사가 재방문을 요청드릴 수도 있습니다."
          },
          {
            id: 4,
            que: "동시에 한 가지 이상의 연구에 참여할 수 있나요?",
            ans:
              "아니요.\n자원자들은 임상시험이 끝난 시점부터 또 다른 임상시험이 시작되는 시점까지 1~3달의 시간차를 갖고 참여해야 합니다."
          },
          {
            id: 5,
            que: "임상시험에 얼마나 자주 참여할 수 있나요?",
            ans:
              "임상시험 완료 후, 1~3달 간의 휴약 기간을 가져야 합니다.\n그 이후에, 자유롭게 다른 임상시험에 참여할 수 있습니다."
          },
          {
            id: 6,
            que: "자원자의 의무는 무엇인가요?",
            ans:
              "자원하는 연구의 종류에 따라 정확한 시험 결과를 위해 지켜야 할 조건들이 있습니다. 예를 들면, 운동, 흡연, 약물과 알코올을 제한해야 할 수 있습니다. 우리는 여러분이 연구에 참여하기 전에 이러한 의무를 알 수 있도록 자세한 정보를 제공해드릴 것입니다."
          },
          {
            id: 7,
            que: "어디에서 예정중인 임상 시험에 대해 볼 수 있나요?",
            ans:
              "'진행중인 연구'를 클릭하면 연구에 대한 더 많은 정보를 보실 수 있습니다.\n임상시험의 제목, 날짜, 보상비 뿐만 아니라 모집하고 있는 자원자의 유형에 대한 자세한 정보를 제공하고 있습니다."
          },
          {
            id: 8,
            que: "누가 연구에 참여할 수 있나요?",
            ans:
              "센터에서 수행되는 임상시험은 일반적으로 만 19세 이상이셔야 참여가 가능하지만, 의학적인 자격 요건은 연구 마다 다양합니다.\n1상 임상시험은 연구 계획서에 의해 결정된 엄격한 건강한 자원자 자격 기준을 갖춘 사람만이 참여가 가능합니다.\n자격 기준은 흡연, 의약품, 약물 사용, 알코올 등을 포함할 수 있습니다.\n2상이나 3상 임상시험은 특정한 의학적인 조건을 가지고 있으면서, 1상과 비슷한 자격 기준을 갖추신 분들이 참여 가능합니다."
          },
          {
            id: 9,
            que: "연구는 어떻게 진행되나요?",
            ans:
              "1상 임상시험에 참여하게 되면 보통 하루 또는 그 이상 동안 병동에 입원을 하게 되며, 여러 번 외래 방문을 하게 되거나 집에서 약 복용을 하게 될 수 있습니다. 입원 기간과 외래 방문의 횟수는 연구에 따라 다릅니다.\n입원 기간 동안에는 여러 번의 채혈, 신체 검사, 활력징후 검사 등이 있을 것이며, 검사가 이루어지지 않는 시간에는 책을 읽거나, 공부를 하거나, TV를 보거나, 게임을 할 수 있으며, 보드게임과 인터넷을 이용하실 수 있습니다."
          },
          {
            id: 10,
            que: "약 복용 중에 참여 가능한가요?",
            ans:
              "각각의 임상시험은 다른 요구 사항을 가지고 있으므로, 참여중인 임상시험에 따라 다릅니다. 대부분의 건강 자원자 임상시험의 경우, 약을 복용 중이라면 참여가 불가능할 수도 있습니다. 만약 단기 치료 중이라면 치료가 끝나고 참여가 가능할 것입니다.\n그러나 환자 대상 연구의 경우에는 약을 복용해도 괜찮은 경우가 있으며, 임상시험은 약 복용이 가능하도록 설계될 것입니다.\n약 복용에 관한 질문이 있을 시 자원자 모집 센터로 연락 주시기 바랍니다."
          }
        ]
      },
      {
        id: 4,
        tabName: "사전검사 (스크리닝)",
        cont: [
          {
            id: 0,
            que: "사전 검사에서 무엇을 하나요?",
            ans:
              "- 신분증을 확인합니다.\n\n- 의료진이 연구에 대해 설명하고 질문을 받습니다.\n\n- 여러분이 연구 참여에 동의한다면 동의서에 서명을 합니다.\n\n- 자세한 의학적, 사회적 정보를 수집합니다.\n\n- 혈액, 소변 샘플을 수집합니다.\n\n- 혈압, 맥박, 심전도를 측정합니다.\n\n - 검사 결과가 나오면 연락해서 다음 단계에 대해 알려드립니다."
          },
          {
            id: 1,
            que: "사전 검사는 얼마나 걸리나요?",
            ans:
              "검사에 요구되는 시간은 연구마다 다릅니다. 평균적으로 2-3시간 걸린다고 보시면 됩니다."
          },
          {
            id: 2,
            que: "왜 연구 참여시에 매번 사전 검사를 받아야 하나요?",
            ans:
              "사전 검사는 임상 시험에 참여할 사람을 선별하기 위한 과정입니다. 임상 시험은 상대적으로 적은 인원을 대상으로 하기 때문에, 연구에서 요구하는 자격을  갖추어 데이터를 잘 제공할 수 있는 사람들이 참여해야 합니다.\n의사들이 검사 결과를 참고하여 연구에 참여할 수 있는 사람을 선택합니다."
          },
          {
            id: 3,
            que: "사전 검사에서 탈락하면 어떻게 되나요?",
            ans:
              "사전 검사에서는 여러 가지 이유로 탈락되실 수 있으며, 사전 검사를 통과하더라도 연구에 참여하지 못하거나 후보로 참여하게 될수 있습니다. 탈락 사유가 무엇인지 여쭤보시면 모두 답변해드립니다. 탈락 후에는 지금 진행중인 다른 연구에 다시 지원이 가능한지 자원자 모집 센터로 문의주시면 됩니다."
          }
        ]
      },
      {
        id: 5,
        tabName: "입원",
        cont: [
          {
            id: 0,
            que: "입원해야만 하나요?",
            ans:
              "참여하고 있는 연구에 따라 다릅니다. 외래 방문 1회 또는 하루 숙박만 하면 되는 경우도 있긴 하지만, 보통 임상 시험 결과를 관찰하기 때문에 더 오래 입원하시게 됩니다.\n병동 안에서는 자유로운 생활이 가능하십니다."
          },
          {
            id: 1,
            que: "입원하려면 무엇을 가져가야 하나요?",
            ans:
              "화장실에 비누, 샴푸, 치약, 드라이어가 비치되어 있으며, 환의, 담요, 세면타월, 슬리퍼, 일회용 면도기, 물컵, 칫솔(2회이상 입원 시 처음만 제공)이 제공됩니다.\n필요하시다면 로션, 샤워용품, 속옷, 읽을거리, 노트북 등을 가져오실 수 있으며, 센터에서는 개인 물품의 분실 또는 도난에 대한 책임을 지지 않습니다."
          },
          {
            id: 2,
            que: "휴대 전화와 노트북은 사용 가능한가요?",
            ans: "네, 가지고 오셔도 됩니다."
          },
          {
            id: 3,
            que: "외출할 수 있나요?",
            ans:
              "대체로 입원 중에는 병동 밖으로 나갈 수 없으며, 장기 입원의 경우 의료진의 동의 하에 외출할 수 있습니다."
          },
          {
            id: 4,
            que: "정해진 날에 참석해야 하나요?",
            ans:
              "네. 각각의 임상시험은 참석해야 하는 날이 정해져 있으므로 정해진 날에 방문하여야 합니다.\n임상 시험의 연구 디자인은 다양하지만, 연구자가 약이 어떻게 작용하는지 보기 위해서는 정해진 시간에 데이터를 수집하는 것이 중요합니다. 이를 위해 여러분은 센터에서 안내한 날짜와 시간을 잘 지켜 방문해야 합니다.\n그러나, 입원이 아닌 방문은 연구에 따라 조정 가능한 경우도 있으니, 자원자 모집 센터로 문의 바랍니다."
          },
          {
            id: 5,
            que: "가족과 친구들이 방문할 수 있나요?",
            ans:
              "우리는 연구의 정확한 결과와 연구 참여자의 기밀을 보장하기 위해 방문자를 허용하지 않습니다. 병동 안에서 새로운 친구를 만들어 보는 것을 권합니다."
          }
        ]
      }
    ]
  },
  recruit: {
    all: "전체",
    male: "남자",
    female: "여자",
    koreanAge: "만",
    month: "개월",
    currency: "원",
    age: "세"
  },
  recruitList: {
    title: "임상시험 모집정보",
    alertAge: "나이를 입력해주세요",
    alertEnt: "참여가능기간을 입력해주세요",
    alertHeight: "키를 입력해주세요",
    alertWeight: "몸무게를 입력해주세요",
    pagingResult: " 건 검색결과",
    buttonReset: "초기화",
    buttonSubmit: "검색",
    buttonTxt: "내가 참여가능한 연구만 보기",
    search: {
      disease: "질환 구분",
      gender: "성별",
      age: "나이",
      smoking: "흡연여부",
      term: "참여가능기간",
      height: "키",
      weight: "몸무게",
      history: "병력",
      select: "병력선택"
    },
    searchRdo: {
      all: "전체",
      male: "남자",
      female: "여자",
      smoking: "흡연",
      nonSmoking: "비흡연",
      input: "입력",
      none: "해당없음",
      yes: "있음"
    },
    loding: "로딩중",
    noResult: "검색결과 없음"
  },
  recruitView: {
    viewTitle: "임상시험 상세내용",
    buttonMember: "회원으로 신청하기",
    buttonNonMember: "비회원으로 신청하기",
    cancerTxt: "※ 종양 연구의 경우 전화 지원만 가능합니다. 연락처 : ",
    closedTxt: "종료된 모집 공고입니다.",
    title: {
      apply: "지원방법",
      gender: "성별",
      age: "나이",
      classify: "연구 분류",
      type: "임상시험\n종류",
      term: "새 모집\n참여 가능\n기간",
      sector: "자원 부문",
      smoker: "흡연자",
      smokerY: "흡연자 참여가능",
      smokerN: "흡연자 참여 불가",
      cancer: "암종",
      disease: "대상질환",
      history: "병력",
      participation: "새 연구 참여 가능 기간",
      reward: "사례비",
      recruitPeriod: "모집기간",
      researchPeriod: "연구기간",
      professor: "담당교수",
      stage: "단계",
      medicine: "임상시험\n약제",
      patient: "대상환자",
      info: "추가정보",
      details: "상세내용",
      files: "첨부파일"
    }
  },
  recruitWrite: {
    cancelTxt: "취소",
    nextTxt: "다음",
    submitTxt: "신청하기",
    cancelMsg: "모집 신청을 취소하시겠습니까?",
    submitMsg: "해당 모집을 신청하시겠습니까?",
    successMsg:
      "자원자 신청이 완료되었습니다.\n해당 모집의 조건에 적합하지 않을 경우\n탈락하실 수 있으므로 양해 부탁드립니다.",
    failMsg: "자원자 신청에 실패하였습니다.",
    alreadyMsg: "이미 신청한 모집 공고입니다.",
    recruitTitle: {
      name: "이름",
      mail: "이메일(ID)",
      phone: "휴대 전화번호",
      contact: "기타 연락처",
      birth: "생년월일",
      gender: "성별",
      genderMale: "남",
      genderFemale: "여",
      addr: "주소",
      joinPath: "가입경로",
      preferrede: "선호하는 연락방법",
      rank1: "1순위",
      rank2: "2순위",
      rank3: "3순위",
      rank4: "4순위",
      rank5: "5순위",
      nation: "민족",
      sector: "자원 부문",
      height: "키",
      weight: "몸무게",
      smoking: "흡연여부",
      history: "병력",
      type: "임상시험 종류",
      disease: "질환 구분",
      term: "새 연구 참여 가능 기간",
      bloodDonation: "헌혈",
      donationDay: "최근헌혈일",
      donationType: "최근 헌혈 타입",
      donationType1: "성분",
      donationType2: "전혈",
      bloodTransfusion: "수혈",
      transfusionDay: "마지막 수혈일",
      joined: "임상시험/\n생물학적 동등성 시험 참여경험",
      joinedDay: "마지막 투여일",
      joined3month:
        "6개월 이내 임상시험 참여 여부\n생물학적 동등성 시험 참여 여부",
      joined3Day: "최근 참여일",
      drug: "약물사용여부",
      drugName: "약물명",
      drugDay: "마지막 투여일",
      drugTxt:
        "예) 30일 이내 사용한 전문의약품(예: 병원에서 처방받은 약, 치료를 요할 정도의 특정 질환으로 장기간 의약품을 복용등),\n 일반의약품(예: 소화제, 감기약, 인공눈물, 안약, 연고, 파스 등) 모두 기재",
      allergy: "알레르기 약물과민성",
      allergyType: "종류",
      allergyDay: "최초 발생일",
      allergyTxt:
        "예) 아토피피부염, 비염, 음식물 알레르기, 천식, 항생제/아스피린/소염진통제 과민반응 등",
      operation: "수술/시술 예정여부",
      operationType: "수술/시술명",
      operationTxt: "예) 임상시험 기간 내에 예정된 수술이나 시술/발치 등",
      surgery: "병력/수술력",
      surgeryType: "병명/시술명",
      surgeryTxt:
        "예) 수술/입원치료, 치료를 요할 정도의 특정 질환, 피부질환(건선, 접촉성 피부염)이나 피내 주사 시 방해가 될 수 있는\n 흉터와 피부 이상 또는 수술의 과거력 등",
      smokingYn: "흡연여부",
      smokingType: "개비/일",
      smokingDay: "마지막 흡연일",
      smokingTxt: "(정확한 개수를 기록하여 주십시오)",
      nonSmoking: "비흡연자",
      smoked: "과거 흡연자",
      smoker: "현재 흡연자",
      step3Type: "종류",
      step3Time: "회/주,",
      step3Day: "마지막 섭취일",
      alcohol: "음주여부",
      alcoholTime: "잔/주,",
      alcoholDay: "마지막 음주일",
      alcoholTxt: "예) 맥주,소주 양주 등",
      caffeine: "카페인함유 식품섭취 여부",
      caffeineTxt:
        "예) 커피 함유 식품, 초콜릿 함유 식품, 차(예: 녹차, 홍차 등) 종류, 탄산음료(예: 콜라 등), 자양강장제(예: 고카페인 음료 등)",
      etcMedicine: "한약/건강기능식품 섭취여부",
      etcMedicineTxt:
        "예) 30일 이내 섭취한 한약(예: 홍삼 등) 또는 건강기능식품(예: 오메가-3 지방산, 비타민 D, 칼슘, 종합비타민 등) 모두 기재",
      diet: "임상시험에 영향을 줄 것으로\n예상되는 비정상적인 식이 섭취여부",
      dietTxt: "예) 단백질, 지방질 위주 식사, 채식만 섭취, 자몽 주스 섭취 등",
      exercise: "운동여부",
      exerciseDay: "최근 운동일",
      meal: "표준식사 가능여부",
      mealTxt: "* 표준식사: 병원에서 제공하는 식사",
      contraception: "임상시험 기간동안 피임 가능 여부",
      precautions: "주의사항 준수 가능 여부",
      precautionsTxt:
        "* 주의사항: 연구에 따라 상이할 수 있으나 임상시험 전 기간 동안에는 타 의약품, 한약, 건강기능식품을 제한하며 음주, 흡연, 헌혈 및 수혈을 하면 안되고 임상시험용의약품, 투여일 약 1주일 전에는 음주, 카페인 함유식품, 자몽 함유 식품들이 금지됩니다. 스크리닝 방문 시 에는 최소 8시간 이상 공복 상태를 유지하고 물을 많이 드시고 신분증을 가지고 오셔야 합니다.",
      caution:
        "작성하신 지원서가 연구에 적합할 경우 전화로 일정 안내 드릴 예정입니다.\n지원서 기재후 병원에 방문하시더라도 연구에 부적합할 경우에는 참여가 불가능하시어 집으로 돌아가실 수 있습니다.\n 전화 상담 내용은 실제 연구 참여를 의미하지 않으며 자발적으로 병원에 방문한 후 의료진과의 상담을 통해 연구 참여 여부가 결정됩니다.\n 모든 자원자는 검사 통과 시에도 후보가 되거나 연구에 참여하지 못할 수 있습니다.\n 검사 방문과 탈락 시 별도의 교통비와 사례비는 지급되지 않습니다.\n 위 내용에 동의하시며 참여 신청을 원하십니까? "
    }
  },
  agree: {
    title: "서울대학교병원 임상시험센터",
    agreeTitle: "개인정보 수집·이용 동의서",
    agreeY: "동의",
    agreeN: "비동의",
    btnCancel: "취소",
    btnSubmit: "진행",
    agreeMsg: "모든 항목에 대해 동의해 주세요.",
    desc: [
      {
        title: "1. 개인정보 수집ㆍ이용 동의서",
        cont:
          "서울대학교병원 임상시험센터는「정보통신망 이용촉진 및 정보보호 등에 관한법률」및「개인정보보호법」에 의거하여 개인정보를수집ㆍ이용할 때 동의를 받고 있습니다."
      },
      {
        title: "① 개인 정보 수집ㆍ이용 목적",
        cont: [
          "ㆍ임상시험 자원자 등록",
          "ㆍ임상시험센터에서 발행하는 각종 행사소식지,임상시험 관련 정보제공"
        ]
      },
      {
        title: "② 개인 정보의 보유ㆍ이용 기간",
        cont:
          "정보수집ㆍ이용목적달성시까지 귀하의 개인정보를 보유할 수 있습니다."
      },
      {
        title: "③ 수집하는 개인 정보의 항목",
        cont: [
          "ㆍ성명, 생년월일, 성별, 민족, 가입경로, 이메일, 메신저ID, 전화번호, 주소, 선호하는연락방법, 탈락사유등연구참여에필요한정보",
          "ㆍ이 외 웹사이트를 통해 임상시험에 자원할 때 자원하기 필드에 기재된항목"
        ]
      },
      {
        title: "④ 개인 정보 수집 ․ 이용 거부 권리",
        cont:
          "시험대상자 또는 시험대상자의 대리인은 개인정보수집을 거부할 권리가 있습니다.수집을 거부하는 경우 임상시험에 참여하지 못 할수있습니다."
      }
    ]
  },
   agree2: {
    agree2Title: "민감정보 수집ㆍ이용 동의서",
    agree2Y: "동의",
    agree2N: "비동의",
    btnCancel: "취소",
    btnSubmit: "진행",
    desc: [
      {
        title: "2. 민감정보 수집·이용 동의서"
        // cont:
        //   "서울대학교병원 임상시험센터는「정보통신망 이용촉진 및 정보보호 등에 관한법률」및「개인정보보호법」에 의거하여 개인정보를수집ㆍ이용할 때 동의를 받고 있습니다."
      },
      {
        title: "① 민감정보 수집ㆍ이용 목적",
        cont: [
          "ㆍ임상시험 자원자 등록",
          "ㆍ임상시험센터에서 발행하는 각종 행사소식지,임상시험 관련 정보제공"
        ]
      },
      {
        title: "② 민감정보의 보유ㆍ이용 기간",
        cont:
          "정보수집ㆍ이용목적달성시까지 귀하의 개인정보를 보유할 수 있습니다."
      },
      {
        title: "③ 수집하는 민감정보의 항목",
        cont: [
          "ㆍ신체정보(신장, 체중)",
          "ㆍ과거 진료기록 등 병력"
        ]
      }
    ]
  },
  //  agree3: {
  //   agree3Title: "전체동의",
  //   agree3Y: "동의",
  //   agree3N: "비동의"
  // },
  contact: {
    title: "오시는길",
    subTitle: "임상시험 자원자 모집 문의",
    contactData: [
      {
        id: 0,
        title: "주소",
        cont:
          "우)03080 서울특별시 종로구 대학로 101(연건동 28번지) 서울대학교병원 의생명연구원 4층"
      },
      { id: 1, title: "전화", cont: "02-741-4221 (평일 오전 9시~오후 6시)" },
      { id: 2, title: "이메일", cont: "snuhctc@gmail.com" }
    ],
    data: [
      {
        id: 0,
        traffic: "교통편(버스)",
        description: [
          {
            id: 0,
            station: "창경궁 서울대학교병원 하행 [01002]",
            way:
              "파랑(간선버스) : 102, 104, 106, 107, 108, 140, 143, 149, 150, 151, 160, 162, 171, 172, 272, 301, 710"
          },
          {
            id: 1,
            station: "창경궁 입구 상행 [01224]",
            way: "파랑(간선버스) : 151, 171, 172, 272, 601"
          },
          {
            id: 2,
            station: "혜화역 서울대학교병원입구 3번출구 앞 하행 [01221]",
            way:
              "파랑(간선버스) : 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 601, 710\n초록(지선버스) : 2112, 종로08"
          },
          {
            id: 3,
            station: "혜화역 마로니에 공원 앞 상행",
            way:
              "파랑(간선버스) : 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 710\n초록(지선버스) : 2112, 종로08, 종로12(병원순환버스)"
          }
        ]
      },
      {
        id: 1,
        traffic: "교통편 (기차, 공항)",
        description: [
          {
            id: 0,
            station: "서울역",
            way: "서울역 지하철 4호선 → 혜화역 3번 출구"
          },
          {
            id: 1,
            station: "용산역",
            way: "신용산역 지하철 4호선 → 혜화역 3번 출구"
          },
          {
            id: 2,
            station: "김포공항",
            way:
              "김포공항역 공항철도 → 서울역(4호선으로 환승) → 혜화역 3번 출구"
          },
          {
            id: 3,
            station: "인천공항",
            way:
              "인천국제공항역 공항철도 → 서울역(4호선으로 환승) → 혜화역 3번 출구"
          }
        ]
      },
      {
        id: 2,
        traffic: "주요 고속 | 시외버스를 이용하실 경우",
        description: [
          {
            id: 0,
            station: "강남터미널",
            way:
              "고속터미널역 지하철 3호선 → 충무로역(4호선으로 환승) → 혜화역 3번 출구"
          },
          {
            id: 1,
            station: "남부터미널",
            way:
              "남부터미널역 지하철 3호선 → 충무로역(4호선으로 환승)→ 혜화역 3번 출구 "
          },
          {
            id: 2,
            station: "동서울터미널",
            way:
              "강변역 지하철 2호선 → 동대문역사문화공원역(4호선으로 환승)→ 혜화역 3번 출구"
          },
          {
            id: 3,
            station: "상봉터미널",
            way:
              "상봉역 지하철 7호선 → 군자역(5호선으로 환승) → 동대문역사문화공원(4호선으로 환승) → 혜화역 3번 출구"
          }
        ]
      }
    ],
    other: {
      traffic: "고속도로(자가용)를 이용하실 경우",
      way:
        "경부선 서울요금소 → 한남대교 → 을지로 → 이화사거리 → 대학로 → 서울대학교병원",
      txt:
        "스크리닝 진행자에 한하여 4시간 무료 주차가 가능합니다. 과거력이나 BMI로 스크리닝 참여 불가시 주차 요금 본인 부담"
    }
  },
  userInfo: {
    infoTitle: "회원정보",
    modifyTitle: "회원정보 수정",
    applyTitle: "임상시험 자원서",
    applyModifyTitle: "임상시험 자원서 수정",
    joinDate: "가입일",
    changePw: "비밀번호 변경",
    male: "남성",
    female: "여성",
    participation: "참여 가능 기간",
    alwaysTit: "항상",
    btnModify: "수정하기",
    btnWithdraw: "탈퇴하기",
    btnSave: "저장하기",
    btnCancel: "취소하기",
    failMsg: "저장에 실패하였습니다."
  },
  withdrawal: {
    title: "회원탈퇴",
    section1: {
      tit: "탈퇴 안내",
      cont:
        "회원 탈퇴를 진행하기 전에 유의사항 및 안내 사항을 꼭 확인해 주세요."
    },
    section2: {
      tit: "이메일(ID) 재사용 및 복구 불가 안내",
      cont:
        "사용하고 계신 이메일(ID)을 탈퇴할 경우 재사용 및 복구가 불가능합니다.\n신중하게 선택하시기 바랍니다."
    },
    section3: {
      tit: "회원정보 및 개인형 서비스 이용 기록 삭제 안내",
      cont:
        "회원정보 및 임상시험 자원서와 자원 내역, 내 문의 현황의 서비스 이용 기록은 모두 삭제되며 삭제된 데이터는 복구되지 않습니다."
    },
    step2: {
      tit: "안전한 회원 탈퇴를 진행하기 위해 비밀번호를 확인해 주세요.",
      cont:
        "비밀번호가 확인되면 이메일(ID)는 즉시 탈퇴됩니다.\n\n사용하고 계신 이메일(ID)을 탈퇴할 경우 재사용 및 복구가 불가능합니다.\n신중하게 선택하시기 바랍니다."
    },
    form: {
      txt1: "이메일(ID)",
      txt2: "비밀번호"
    },
    btnCancel: "탈퇴취소",
    btnStepNext: "다음단계",
    btnWithdraw: "탈퇴하기"
  },
  recruitHistory: {
    title: "자원 내역"
  }
};
